function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import closest from '../shared/utils/closest/closest.mjs';
import Announcement from './Plugins/Announcement/Announcement.mjs';
import Focusable from './Plugins/Focusable/Focusable.mjs';
import Mirror from './Plugins/Mirror/Mirror.mjs';
import Scrollable from './Plugins/Scrollable/Scrollable.mjs';
import Emitter from './Emitter/Emitter.mjs';
import MouseSensor from './Sensors/MouseSensor/MouseSensor.mjs';
import TouchSensor from './Sensors/TouchSensor/TouchSensor.mjs';
import './Sensors/SensorEvent/SensorEvent.mjs';
import { DraggableInitializedEvent, DraggableDestroyEvent } from './DraggableEvent/DraggableEvent.mjs';
import { DragStartEvent, DragMoveEvent, DragOutEvent, DragOutContainerEvent, DragOverContainerEvent, DragOverEvent, DragStopEvent, DragStoppedEvent, DragPressureEvent } from './DragEvent/DragEvent.mjs';
var onDragStart = Symbol('onDragStart');
var onDragMove = Symbol('onDragMove');
var onDragStop = Symbol('onDragStop');
var onDragPressure = Symbol('onDragPressure');
var dragStop = Symbol('dragStop');
var defaultAnnouncements = {
  'drag:start': function dragStart(event) {
    return "Picked up ".concat(event.source.textContent.trim() || event.source.id || 'draggable element');
  },
  'drag:stop': function dragStop(event) {
    return "Released ".concat(event.source.textContent.trim() || event.source.id || 'draggable element');
  }
};
var defaultClasses = {
  'container:dragging': 'draggable-container--is-dragging',
  'source:dragging': 'draggable-source--is-dragging',
  'source:placed': 'draggable-source--placed',
  'container:placed': 'draggable-container--placed',
  'body:dragging': 'draggable--is-dragging',
  'draggable:over': 'draggable--over',
  'container:over': 'draggable-container--over',
  'source:original': 'draggable--original',
  mirror: 'draggable-mirror'
};
var defaultOptions = {
  draggable: '.draggable-source',
  handle: null,
  delay: {},
  distance: 0,
  placedTimeout: 800,
  plugins: [],
  sensors: [],
  exclude: {
    plugins: [],
    sensors: []
  }
};

var Draggable = /*#__PURE__*/function () {
  function Draggable() {
    var _this = this;

    var containers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [document.body];
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, Draggable);

    if (containers instanceof NodeList || containers instanceof Array) {
      this.containers = _toConsumableArray(containers);
    } else if (containers instanceof HTMLElement) {
      this.containers = [containers];
    } else {
      throw new Error('Draggable containers are expected to be of type `NodeList`, `HTMLElement[]` or `HTMLElement`');
    }

    this.options = _objectSpread(_objectSpread(_objectSpread({}, defaultOptions), options), {}, {
      classes: _objectSpread(_objectSpread({}, defaultClasses), options.classes || {}),
      announcements: _objectSpread(_objectSpread({}, defaultAnnouncements), options.announcements || {}),
      exclude: {
        plugins: options.exclude && options.exclude.plugins || [],
        sensors: options.exclude && options.exclude.sensors || []
      }
    });
    this.emitter = new Emitter();
    this.dragging = false;
    this.plugins = [];
    this.sensors = [];
    this[onDragStart] = this[onDragStart].bind(this);
    this[onDragMove] = this[onDragMove].bind(this);
    this[onDragStop] = this[onDragStop].bind(this);
    this[onDragPressure] = this[onDragPressure].bind(this);
    this[dragStop] = this[dragStop].bind(this);
    document.addEventListener('drag:start', this[onDragStart], true);
    document.addEventListener('drag:move', this[onDragMove], true);
    document.addEventListener('drag:stop', this[onDragStop], true);
    document.addEventListener('drag:pressure', this[onDragPressure], true);
    var defaultPlugins = Object.values(Draggable.Plugins).filter(function (Plugin) {
      return !_this.options.exclude.plugins.includes(Plugin);
    });
    var defaultSensors = Object.values(Draggable.Sensors).filter(function (sensor) {
      return !_this.options.exclude.sensors.includes(sensor);
    });
    this.addPlugin.apply(this, [].concat(_toConsumableArray(defaultPlugins), _toConsumableArray(this.options.plugins)));
    this.addSensor.apply(this, [].concat(_toConsumableArray(defaultSensors), _toConsumableArray(this.options.sensors)));
    var draggableInitializedEvent = new DraggableInitializedEvent({
      draggable: this
    });
    this.on('mirror:created', function (_ref) {
      var mirror = _ref.mirror;
      return _this.mirror = mirror;
    });
    this.on('mirror:destroy', function () {
      return _this.mirror = null;
    });
    this.trigger(draggableInitializedEvent);
  }

  _createClass(Draggable, [{
    key: "destroy",
    value: function destroy() {
      document.removeEventListener('drag:start', this[onDragStart], true);
      document.removeEventListener('drag:move', this[onDragMove], true);
      document.removeEventListener('drag:stop', this[onDragStop], true);
      document.removeEventListener('drag:pressure', this[onDragPressure], true);
      var draggableDestroyEvent = new DraggableDestroyEvent({
        draggable: this
      });
      this.trigger(draggableDestroyEvent);
      this.removePlugin.apply(this, _toConsumableArray(this.plugins.map(function (plugin) {
        return plugin.constructor;
      })));
      this.removeSensor.apply(this, _toConsumableArray(this.sensors.map(function (sensor) {
        return sensor.constructor;
      })));
    }
  }, {
    key: "addPlugin",
    value: function addPlugin() {
      var _this2 = this;

      for (var _len = arguments.length, plugins = new Array(_len), _key = 0; _key < _len; _key++) {
        plugins[_key] = arguments[_key];
      }

      var activePlugins = plugins.map(function (Plugin) {
        return new Plugin(_this2);
      });
      activePlugins.forEach(function (plugin) {
        return plugin.attach();
      });
      this.plugins = [].concat(_toConsumableArray(this.plugins), _toConsumableArray(activePlugins));
      return this;
    }
  }, {
    key: "removePlugin",
    value: function removePlugin() {
      for (var _len2 = arguments.length, plugins = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        plugins[_key2] = arguments[_key2];
      }

      var removedPlugins = this.plugins.filter(function (plugin) {
        return plugins.includes(plugin.constructor);
      });
      removedPlugins.forEach(function (plugin) {
        return plugin.detach();
      });
      this.plugins = this.plugins.filter(function (plugin) {
        return !plugins.includes(plugin.constructor);
      });
      return this;
    }
  }, {
    key: "addSensor",
    value: function addSensor() {
      var _this3 = this;

      for (var _len3 = arguments.length, sensors = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        sensors[_key3] = arguments[_key3];
      }

      var activeSensors = sensors.map(function (Sensor) {
        return new Sensor(_this3.containers, _this3.options);
      });
      activeSensors.forEach(function (sensor) {
        return sensor.attach();
      });
      this.sensors = [].concat(_toConsumableArray(this.sensors), _toConsumableArray(activeSensors));
      return this;
    }
  }, {
    key: "removeSensor",
    value: function removeSensor() {
      for (var _len4 = arguments.length, sensors = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        sensors[_key4] = arguments[_key4];
      }

      var removedSensors = this.sensors.filter(function (sensor) {
        return sensors.includes(sensor.constructor);
      });
      removedSensors.forEach(function (sensor) {
        return sensor.detach();
      });
      this.sensors = this.sensors.filter(function (sensor) {
        return !sensors.includes(sensor.constructor);
      });
      return this;
    }
  }, {
    key: "addContainer",
    value: function addContainer() {
      for (var _len5 = arguments.length, containers = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
        containers[_key5] = arguments[_key5];
      }

      this.containers = [].concat(_toConsumableArray(this.containers), containers);
      this.sensors.forEach(function (sensor) {
        return sensor.addContainer.apply(sensor, containers);
      });
      return this;
    }
  }, {
    key: "removeContainer",
    value: function removeContainer() {
      for (var _len6 = arguments.length, containers = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
        containers[_key6] = arguments[_key6];
      }

      this.containers = this.containers.filter(function (container) {
        return !containers.includes(container);
      });
      this.sensors.forEach(function (sensor) {
        return sensor.removeContainer.apply(sensor, containers);
      });
      return this;
    }
  }, {
    key: "on",
    value: function on(type) {
      var _this$emitter;

      for (var _len7 = arguments.length, callbacks = new Array(_len7 > 1 ? _len7 - 1 : 0), _key7 = 1; _key7 < _len7; _key7++) {
        callbacks[_key7 - 1] = arguments[_key7];
      }

      (_this$emitter = this.emitter).on.apply(_this$emitter, [type].concat(callbacks));

      return this;
    }
  }, {
    key: "off",
    value: function off(type, callback) {
      this.emitter.off(type, callback);
      return this;
    }
  }, {
    key: "trigger",
    value: function trigger(event) {
      this.emitter.trigger(event);
      return this;
    }
  }, {
    key: "getClassNameFor",
    value: function getClassNameFor(name) {
      return this.getClassNamesFor(name)[0];
    }
  }, {
    key: "getClassNamesFor",
    value: function getClassNamesFor(name) {
      var classNames = this.options.classes[name];

      if (classNames instanceof Array) {
        return classNames;
      } else if (typeof classNames === 'string' || classNames instanceof String) {
        return [classNames];
      } else {
        return [];
      }
    }
  }, {
    key: "isDragging",
    value: function isDragging() {
      return Boolean(this.dragging);
    }
  }, {
    key: "getDraggableElements",
    value: function getDraggableElements() {
      var _this4 = this;

      return this.containers.reduce(function (current, container) {
        return [].concat(_toConsumableArray(current), _toConsumableArray(_this4.getDraggableElementsForContainer(container)));
      }, []);
    }
  }, {
    key: "getDraggableElementsForContainer",
    value: function getDraggableElementsForContainer(container) {
      var _this5 = this;

      var allDraggableElements = container.querySelectorAll(this.options.draggable);
      return _toConsumableArray(allDraggableElements).filter(function (childElement) {
        return childElement !== _this5.originalSource && childElement !== _this5.mirror;
      });
    }
  }, {
    key: "cancel",
    value: function cancel() {
      this[dragStop]();
    }
  }, {
    key: onDragStart,
    value: function value(event) {
      var _this$originalSource$,
          _this$source$classLis,
          _this$sourceContainer,
          _document$body$classL,
          _this6 = this;

      var sensorEvent = getSensorEvent(event);
      var target = sensorEvent.target,
          container = sensorEvent.container,
          originalSource = sensorEvent.originalSource;

      if (!this.containers.includes(container)) {
        return;
      }

      if (this.options.handle && target && !closest(target, this.options.handle)) {
        sensorEvent.cancel();
        return;
      }

      this.originalSource = originalSource;
      this.sourceContainer = container;

      if (this.lastPlacedSource && this.lastPlacedContainer) {
        var _this$lastPlacedSourc, _this$lastPlacedConta;

        clearTimeout(this.placedTimeoutID);

        (_this$lastPlacedSourc = this.lastPlacedSource.classList).remove.apply(_this$lastPlacedSourc, _toConsumableArray(this.getClassNamesFor('source:placed')));

        (_this$lastPlacedConta = this.lastPlacedContainer.classList).remove.apply(_this$lastPlacedConta, _toConsumableArray(this.getClassNamesFor('container:placed')));
      }

      this.source = this.originalSource.cloneNode(true);
      this.originalSource.parentNode.insertBefore(this.source, this.originalSource);
      this.originalSource.style.display = 'none';
      var dragStartEvent = new DragStartEvent({
        source: this.source,
        originalSource: this.originalSource,
        sourceContainer: container,
        sensorEvent: sensorEvent
      });
      this.trigger(dragStartEvent);
      this.dragging = !dragStartEvent.canceled();

      if (dragStartEvent.canceled()) {
        this.source.remove();
        this.originalSource.style.display = null;
        return;
      }

      (_this$originalSource$ = this.originalSource.classList).add.apply(_this$originalSource$, _toConsumableArray(this.getClassNamesFor('source:original')));

      (_this$source$classLis = this.source.classList).add.apply(_this$source$classLis, _toConsumableArray(this.getClassNamesFor('source:dragging')));

      (_this$sourceContainer = this.sourceContainer.classList).add.apply(_this$sourceContainer, _toConsumableArray(this.getClassNamesFor('container:dragging')));

      (_document$body$classL = document.body.classList).add.apply(_document$body$classL, _toConsumableArray(this.getClassNamesFor('body:dragging')));

      applyUserSelect(document.body, 'none');
      requestAnimationFrame(function () {
        var oldSensorEvent = getSensorEvent(event);
        var newSensorEvent = oldSensorEvent.clone({
          target: _this6.source
        });

        _this6[onDragMove](_objectSpread(_objectSpread({}, event), {}, {
          detail: newSensorEvent
        }));
      });
    }
  }, {
    key: onDragMove,
    value: function value(event) {
      if (!this.dragging) {
        return;
      }

      var sensorEvent = getSensorEvent(event);
      var container = sensorEvent.container;
      var target = sensorEvent.target;
      var dragMoveEvent = new DragMoveEvent({
        source: this.source,
        originalSource: this.originalSource,
        sourceContainer: container,
        sensorEvent: sensorEvent
      });
      this.trigger(dragMoveEvent);

      if (dragMoveEvent.canceled()) {
        sensorEvent.cancel();
      }

      target = closest(target, this.options.draggable);
      var withinCorrectContainer = closest(sensorEvent.target, this.containers);
      var overContainer = sensorEvent.overContainer || withinCorrectContainer;
      var isLeavingContainer = this.currentOverContainer && overContainer !== this.currentOverContainer;
      var isLeavingDraggable = this.currentOver && target !== this.currentOver;
      var isOverContainer = overContainer && this.currentOverContainer !== overContainer;
      var isOverDraggable = withinCorrectContainer && target && this.currentOver !== target;

      if (isLeavingDraggable) {
        var _this$currentOver$cla;

        var dragOutEvent = new DragOutEvent({
          source: this.source,
          originalSource: this.originalSource,
          sourceContainer: container,
          sensorEvent: sensorEvent,
          over: this.currentOver,
          overContainer: this.currentOverContainer
        });

        (_this$currentOver$cla = this.currentOver.classList).remove.apply(_this$currentOver$cla, _toConsumableArray(this.getClassNamesFor('draggable:over')));

        this.currentOver = null;
        this.trigger(dragOutEvent);
      }

      if (isLeavingContainer) {
        var _this$currentOverCont;

        var dragOutContainerEvent = new DragOutContainerEvent({
          source: this.source,
          originalSource: this.originalSource,
          sourceContainer: container,
          sensorEvent: sensorEvent,
          overContainer: this.currentOverContainer
        });

        (_this$currentOverCont = this.currentOverContainer.classList).remove.apply(_this$currentOverCont, _toConsumableArray(this.getClassNamesFor('container:over')));

        this.currentOverContainer = null;
        this.trigger(dragOutContainerEvent);
      }

      if (isOverContainer) {
        var _overContainer$classL;

        (_overContainer$classL = overContainer.classList).add.apply(_overContainer$classL, _toConsumableArray(this.getClassNamesFor('container:over')));

        var dragOverContainerEvent = new DragOverContainerEvent({
          source: this.source,
          originalSource: this.originalSource,
          sourceContainer: container,
          sensorEvent: sensorEvent,
          overContainer: overContainer
        });
        this.currentOverContainer = overContainer;
        this.trigger(dragOverContainerEvent);
      }

      if (isOverDraggable) {
        var _target$classList;

        (_target$classList = target.classList).add.apply(_target$classList, _toConsumableArray(this.getClassNamesFor('draggable:over')));

        var dragOverEvent = new DragOverEvent({
          source: this.source,
          originalSource: this.originalSource,
          sourceContainer: container,
          sensorEvent: sensorEvent,
          overContainer: overContainer,
          over: target
        });
        this.currentOver = target;
        this.trigger(dragOverEvent);
      }
    }
  }, {
    key: dragStop,
    value: function value(event) {
      var _this$source$classLis2,
          _this$originalSource$2,
          _this$originalSource$3,
          _this$sourceContainer2,
          _this$sourceContainer3,
          _document$body$classL2,
          _this7 = this;

      if (!this.dragging) {
        return;
      }

      this.dragging = false;
      var dragStopEvent = new DragStopEvent({
        source: this.source,
        originalSource: this.originalSource,
        sensorEvent: event ? event.sensorEvent : null,
        sourceContainer: this.sourceContainer
      });
      this.trigger(dragStopEvent);
      if (!dragStopEvent.canceled()) this.source.parentNode.insertBefore(this.originalSource, this.source);
      this.source.remove();
      this.originalSource.style.display = '';

      (_this$source$classLis2 = this.source.classList).remove.apply(_this$source$classLis2, _toConsumableArray(this.getClassNamesFor('source:dragging')));

      (_this$originalSource$2 = this.originalSource.classList).remove.apply(_this$originalSource$2, _toConsumableArray(this.getClassNamesFor('source:original')));

      (_this$originalSource$3 = this.originalSource.classList).add.apply(_this$originalSource$3, _toConsumableArray(this.getClassNamesFor('source:placed')));

      (_this$sourceContainer2 = this.sourceContainer.classList).add.apply(_this$sourceContainer2, _toConsumableArray(this.getClassNamesFor('container:placed')));

      (_this$sourceContainer3 = this.sourceContainer.classList).remove.apply(_this$sourceContainer3, _toConsumableArray(this.getClassNamesFor('container:dragging')));

      (_document$body$classL2 = document.body.classList).remove.apply(_document$body$classL2, _toConsumableArray(this.getClassNamesFor('body:dragging')));

      applyUserSelect(document.body, '');

      if (this.currentOver) {
        var _this$currentOver$cla2;

        (_this$currentOver$cla2 = this.currentOver.classList).remove.apply(_this$currentOver$cla2, _toConsumableArray(this.getClassNamesFor('draggable:over')));
      }

      if (this.currentOverContainer) {
        var _this$currentOverCont2;

        (_this$currentOverCont2 = this.currentOverContainer.classList).remove.apply(_this$currentOverCont2, _toConsumableArray(this.getClassNamesFor('container:over')));
      }

      this.lastPlacedSource = this.originalSource;
      this.lastPlacedContainer = this.sourceContainer;
      this.placedTimeoutID = setTimeout(function () {
        if (_this7.lastPlacedSource) {
          var _this7$lastPlacedSour;

          (_this7$lastPlacedSour = _this7.lastPlacedSource.classList).remove.apply(_this7$lastPlacedSour, _toConsumableArray(_this7.getClassNamesFor('source:placed')));
        }

        if (_this7.lastPlacedContainer) {
          var _this7$lastPlacedCont;

          (_this7$lastPlacedCont = _this7.lastPlacedContainer.classList).remove.apply(_this7$lastPlacedCont, _toConsumableArray(_this7.getClassNamesFor('container:placed')));
        }

        _this7.lastPlacedSource = null;
        _this7.lastPlacedContainer = null;
      }, this.options.placedTimeout);
      var dragStoppedEvent = new DragStoppedEvent({
        source: this.source,
        originalSource: this.originalSource,
        sensorEvent: event ? event.sensorEvent : null,
        sourceContainer: this.sourceContainer
      });
      this.trigger(dragStoppedEvent);
      this.source = null;
      this.originalSource = null;
      this.currentOverContainer = null;
      this.currentOver = null;
      this.sourceContainer = null;
    }
  }, {
    key: onDragStop,
    value: function value(event) {
      this[dragStop](event);
    }
  }, {
    key: onDragPressure,
    value: function value(event) {
      if (!this.dragging) {
        return;
      }

      var sensorEvent = getSensorEvent(event);
      var source = this.source || closest(sensorEvent.originalEvent.target, this.options.draggable);
      var dragPressureEvent = new DragPressureEvent({
        sensorEvent: sensorEvent,
        source: source,
        pressure: sensorEvent.pressure
      });
      this.trigger(dragPressureEvent);
    }
  }]);

  return Draggable;
}();

Draggable.Plugins = {
  Announcement: Announcement,
  Focusable: Focusable,
  Mirror: Mirror,
  Scrollable: Scrollable
};
Draggable.Sensors = {
  MouseSensor: MouseSensor,
  TouchSensor: TouchSensor
};

function getSensorEvent(event) {
  return event.detail;
}

function applyUserSelect(element, value) {
  element.style.webkitUserSelect = value;
  element.style.mozUserSelect = value;
  element.style.msUserSelect = value;
  element.style.oUserSelect = value;
  element.style.userSelect = value;
}

export { Draggable as default, defaultOptions };